import React from 'react';
import { Stats } from '../../../../components/app/DashboardStats/Stats';
import { Asset, Shift } from '../../../../types/app/asset.types';
import { useTranslation } from '../../../../contexts/translation';
import {
  BLUE,
  DARK_BLUE,
  DARK_GREEN,
  DARK_RED,
  GREEN,
  RED,
} from '../../../../utils/core/functions/colors.function';
import { Grid, Theme, useMediaQuery } from '@mui/material';
import { ThemeType } from '../../../../hooks/useLocalTheme';
interface Props {
  shift_1: Shift;
  dataShift_1: any;
  shift_2: Shift;
  dataShift_2: any;
  localTheme?: ThemeType;
  asset: Asset;
}

export function StatsDataLoaderBottom({
  shift_1,
  shift_2,
  dataShift_1,
  dataShift_2,
  localTheme,
  asset,
}: Props) {
  const { t } = useTranslation();
  const title_1 = shift_1.name.split(' ')[0];
  const title_2 = shift_2.name.split(' ')[0];
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  // spojit countery
  const combineCountersSums = (counterData: any[]) => {
    let combinedSum: number = 0;
    counterData.map((c: any) => {
      combinedSum += c.valuesSum;
    });
    return combinedSum;
  };

  return (
    <Stats
      items={[
        {
          id: 0,
          label: `${title_1} ${t('page.dashboard.stats.bottom-panel-headline-1')}`,
          value: `${dataShift_1.planedDataSum.toLocaleString()} ${
            asset.unitOverride || t('general.units.stats-pieces')
          }`,
          textColor: localTheme === ThemeType.DARK ? DARK_BLUE : BLUE,
        },
        {
          id: 1,
          label: t('page.dashboard.stats.bottom-panel-headline-2'),
          value: `${
            dataShift_1.counterData.data.length > 0
              ? combineCountersSums(dataShift_1.counterData.data).toLocaleString()
              : 0
          } ${asset.unitOverride || t('general.units.stats-pieces')}`,
          textColor:
            // counter sum < plan --> červeně, jinak zeleně
            (dataShift_1.counterData.data.length > 0
              ? combineCountersSums(dataShift_1.counterData.data)
              : 0) < dataShift_1.planedDataSum
              ? localTheme === ThemeType.DARK
                ? DARK_RED
                : RED
              : localTheme === ThemeType.DARK
              ? DARK_GREEN
              : GREEN,
        },
        {
          id: 2,
          label: `${title_2} ${t('page.dashboard.stats.bottom-panel-headline-1')}`,
          value: `${dataShift_2.planedDataSum.toLocaleString()} ${
            asset.unitOverride || t('general.units.stats-pieces')
          }`,
          textColor: localTheme === ThemeType.DARK ? DARK_BLUE : BLUE,
        },
        {
          id: 3,
          label: t('page.dashboard.stats.bottom-panel-headline-2'),

          value: `${
            dataShift_2.counterData.data.length > 0
              ? combineCountersSums(dataShift_2.counterData.data).toLocaleString()
              : 0
          } ${asset.unitOverride || t('general.units.stats-pieces')}`,
          textColor:
            // counter sum < plan --> červeně, jinak zeleně
            (dataShift_2.counterData.data.length > 0
              ? combineCountersSums(dataShift_2.counterData.data)
              : 0) < dataShift_2.planedDataSum
              ? localTheme === ThemeType.DARK
                ? DARK_RED
                : RED
              : localTheme === ThemeType.DARK
              ? DARK_GREEN
              : GREEN,
        },
      ]}
      columnsCount={isMobileView ? 1 : 2}
      direction={'row'}
      marginTop={1}
    />
  );
}
